import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/catch";
import { of } from "rxjs/observable/of";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { INSIGHTS } from "constants/action-types";
import type { IStore } from "reducers";
import { CategoryInsights } from "models/insights/category-insights";
import { stringify } from "querystring";

export const fetchCategoryInsightsEpic = (action$, store) =>
    action$.ofType(INSIGHTS.FETCH_CATEGORY_INSIGHTS.START).switchMap(({ payload }) => {
        const state: IStore = store.getState();
        const brandId = state.scope.brand._id;

        const query = {
            viewAsCompanyId: payload.viewAsCompanyId,
        };

        let url = "";

        if (payload.viewAsCompanyId) {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/categories?${stringify(query)}`;
        } else {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/categories`;
        }

        return ajax({
            url,
            method: "GET",
            withCredentials: true,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
            },
            handle401: false,
        })
            .map(({ response, status }) => {
                if (status !== 200) {
                    throw new Error(response.message || "Unknown fetch error");
                }
                return {
                    type: INSIGHTS.FETCH_CATEGORY_INSIGHTS.COMPLETED,
                    categories: mapResponseToCategories(response),
                };
            })
            .catch((error) =>
                of({
                    type: INSIGHTS.FETCH_CATEGORY_INSIGHTS.ERROR,
                    error: `Failed to fetch category insights: ${error.message}`,
                })
            );
    });

// Helper function to map API response to CategoryInsights objects
const mapResponseToCategories = (responseData) => {
    const categoryList = [];

    if (Array.isArray(responseData.categories)) {
        responseData.categories.forEach((data) => {
            const category = new CategoryInsights(data);
            categoryList.push(category);
        });
    }
    return categoryList;
};
